












import { defineComponent, ref } from '@vue/composition-api';
import { Dialog } from 'vant';

import IdentityScoreDialog from '@/components/trade-dialog';
import { CreditDataType } from '@/api/homeV2Status/types';
import { IndentityCode, IndentityScoreEnum } from '@/mixins/finance-identity/types';
import { RouterV2Enum, RouterV3Enum } from '@/router/router-names';
import BioApi from '@/api/bio';
import { session } from '@/shared/utils/storage';
import { Loading } from '@/shared/utils/loading';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { UserInfoStatus } from '@/enums/UserInfoStatus';
import { UploadProcessTypeEnum, OcrProcessSourceEnum } from '@/shared/tools/ocr/enum';
import { ubtSetupPageButton, ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import { changeTabbarMaskStatus } from '@/api/native/container';
import { getTabIdByPath } from '@/shared/utils/getTabIdByPath/getTabIdByPath';
import { TC_OCR_NOT_CLEAR_POPUP } from '@/shared/tools/ocr/tianqi';

export default defineComponent({
  components: {
    IdentityScoreDialog,
  },
  setup(props, context) {
    const { $route, $router } = context.root;
    const creditData = ref<CreditDataType | null>();
    const identityScoreBizeData = ref<IndentityCode>({
      bizCode: 0,
      message: '',
    });
    const shouldUpdateIdentityPhoto = ref(false);

    const identityScorePhoto = (): boolean => (
      identityScoreBizeData.value
        && [
          IndentityScoreEnum.sateBizCodeTypeHua,
          IndentityScoreEnum.sateBizCodeTypeTecent,
        ].includes(identityScoreBizeData.value.bizCode)
    );

    const onCloseIdentity = () => {
      ubtSetupPageButton(TC_OCR_NOT_CLEAR_POPUP, {
        // 按钮类型buttonType：关闭-0 / 我知道了-1
        buttonType: '0',
        processType: UploadProcessTypeEnum.SCAN,
      });
    };

    /** 确认  */
    const onConfirmIdentity = () => {
      ubtSetupPageButton(TC_OCR_NOT_CLEAR_POPUP, {
        // 按钮类型buttonType：关闭-0 / 我知道了-1
        buttonType: '1',
        processType: UploadProcessTypeEnum.SCAN,
      });

      shouldUpdateIdentityPhoto.value = false;
      /** 隐藏tabbar遮罩 */
      changeTabbarMaskStatus({
        show: false,
        duration: 100,
        tabId: getTabIdByPath(),
      });
      const { path, query } = $route;
      const { step } = query;
      const { fillInTheInformation } = creditData.value || {};

      /** TODO:历史逻辑-待优化，若是“提现页”，身份证清晰分不足的场景，不外跳到补充资料页面 */
      if (path !== RouterV2Enum.applyProduct && path !== RouterV2Enum.verifyCredit) {
        Dialog.close();

        if (fillInTheInformation !== UserInfoStatus.Completed) {
          /** 跳转到补充资料页，进行授信主流程(其内部兼容身份证清晰度不足的场景) */
          jumpToVerifyCredit(VerifySceneEnum.CREDIT_WITH_INVALID_IDENTITY, { useReplace: true });
        } else {
          /** 跳转到资料页，进行身份证更新 */
          jumpToVerifyCredit(VerifySceneEnum.PERSONAL_IDENTITY_MODIFY, { useReplace: true });
        }
      } else {
        Dialog.close();
      }
    };

    const updatedIdentityScore = async (scene?: OcrProcessSourceEnum): Promise<void> => {
      try {
        const identityScoreBize = await BioApi.updatedIdentity({
          scene,
        });

        if (session.get('identityScoreBizeData')) {
          session.remove('identityScoreBizeData');
        }

        session.set('identityScoreBizeData', identityScoreBize);
        identityScoreBizeData.value = identityScoreBize;
      } catch (error) {
        // 避免接口失败阻塞页面渲染
      }
    };

    const confirmShouldIdentityScore = (notClearCallback?: () => void): boolean => {
      identityScoreBizeData.value = session.get('identityScoreBizeData') || {
        bizCode: 0,
        message: '',
      };

      if (identityScorePhoto()) {
        if (notClearCallback) {
          notClearCallback();
        }

        ubtSetupModuleExpose(TC_OCR_NOT_CLEAR_POPUP, { processType: UploadProcessTypeEnum.SCAN });
        Loading.clearAll();

        shouldUpdateIdentityPhoto.value = true;

        /** 在首页 我的页面 才显示遮罩 */
        if ($route.path === RouterV2Enum.qualityHomePage
          || $route.path === RouterV2Enum.taglessHome
          || $route.path === RouterV2Enum.home
          || $route.path === RouterV3Enum.home
          || $route.path === RouterV2Enum.myProfile) {
          changeTabbarMaskStatus({
            show: true,
            duration: 100,
            tabId: getTabIdByPath(),
          });
        }
        return false;
      }

      return true;
    };

    return {
      creditData,
      identityScoreBizeData,
      shouldUpdateIdentityPhoto,

      identityScorePhoto,
      onCloseIdentity,
      onConfirmIdentity,
      updatedIdentityScore,
      confirmShouldIdentityScore,
    };
  },
});

